import { render, staticRenderFns } from "./NetaListAttractionComponent.vue?vue&type=template&id=5117f559&scoped=true&"
import script from "./NetaListAttractionComponent.vue?vue&type=script&lang=js&"
export * from "./NetaListAttractionComponent.vue?vue&type=script&lang=js&"
import style0 from "./NetaListAttractionComponent.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./NetaListAttractionComponent.vue?vue&type=style&index=1&id=5117f559&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5117f559",
  null
  
)

export default component.exports